export const environment = {
    production: false,
    baseUrl: 'https://test-api.redro.ru/api',
    galleryPath: 'https://test-api.redro.ru/api/local-files/get-product-image/',
    imagePath: 'https://test-cdn.redro.ru',
    // imagePath: 'https://test-api.redro.ru/api/local-files/get-image/'
};
